module.exports = __webpack_public_path__ + "img/jko-pay.97b25410.svg";